import { useCookies as useOriginalUseCookie } from "react-cookie";

export const useCookies = () =>
  useOriginalUseCookie([
    "controlCookie",
    "advertisingCookies",
    "mandatoryCookies",
    "performanceCookies",
  ]);
